/**
 * @generated SignedSource<<70e6e74ef9fbef623b5bd1599e432c51>>
 * @relayHash e7f5ae3e2fe43434e83ecc989b3f3f0e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 754349f913fd3517ba0b47d0f538b86026d50c09588408409e925c0487acda93

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type utils_triggerRovoAgentMutation$variables = {
  agentId: string;
  issueAri: string;
};
export type utils_triggerRovoAgentMutation$data = {
  readonly devai_invokeAutodevRovoAgent: {
    readonly conversationId: string | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type utils_triggerRovoAgentMutation = {
  response: utils_triggerRovoAgentMutation$data;
  variables: utils_triggerRovoAgentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "agentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "agentId",
    "variableName": "agentId"
  },
  {
    "kind": "Variable",
    "name": "issueId",
    "variableName": "issueAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "conversationId"
},
v4 = {
  "kind": "ScalarField",
  "name": "success"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "utils_triggerRovoAgentMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "DevAiInvokeAutodevRovoAgentPayload",
        "kind": "LinkedField",
        "name": "devai_invokeAutodevRovoAgent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "utils_triggerRovoAgentMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "DevAiInvokeAutodevRovoAgentPayload",
        "kind": "LinkedField",
        "name": "devai_invokeAutodevRovoAgent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "754349f913fd3517ba0b47d0f538b86026d50c09588408409e925c0487acda93",
    "metadata": {},
    "name": "utils_triggerRovoAgentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "78107f5766d4a88329a1609dc07c3bb4";

export default node;
